module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 left_col menu_fixed"
  }, [_c('div', {
    staticClass: "left_col scroll-view"
  }, [_c('div', {
    staticClass: "navbar nav_title",
    staticStyle: {
      "border": "0"
    }
  }, [_c('router-link', {
    staticClass: "site_title",
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.title ? _vm.title : 'Edexis') + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "main_menu_side hidden-print main_menu",
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('div', {
    staticClass: "menu_section active"
  }, [_c('ul', {
    staticClass: "nav side-menu"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": {
          name: item.name
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    }), _vm._v("\n              " + _vm._s(item.title) + "\n              "), (typeof item.pill !== 'undefined') ? _c('span', {
      staticClass: "label label-success pull-right"
    }, [_vm._v("\n                " + _vm._s(item.pill) + "\n              ")]) : _vm._e()])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-footer"
  }, [_c('h5', {
    staticClass: "hidden-sm time"
  }, [_vm._v("\n        " + _vm._s(_vm.time) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "pointer pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logoutPress()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dacb2f1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Sidebar.vue
// module id = 339
// module chunks = 1